const icon = require('./icons/person-lying-down-100.png')

export const FallIcon = () => {
  return <img src={icon} alt="fall icon" className="w-full h-full"/>
}